import React from 'react';
import * as Render from '../../platformui/Base/Render';
import Section from '../../platformui/Section';
import ImageBlock from '../../blocks/image-block';
import LinkBlock from '../../blocks/link-list-block';
import classNames from 'classnames';

const LinkCollectionBlock = (props) => (
  <LinkBlock {...props} className={'error404-linklist'} />
);

const Blocks = {
  ImageBlock,
  LinkCollectionBlock,
};

const ErrorPage404 = (props) => {
  const introClasses = classNames({
    'medium-offset-2': true,
    'medium-8': true,
    'large-offset-0': true,
    'large-8': true,
    'large-centered': true,
    'u-text-center': true,
    columns: true,
  });

  return (
    <main id="content" className="main">
      {(props.Content.Heading || props.Content.Preamble) && (
        <Section Modifiers={{ 'c-section--last': true }}>
          <div className="row">
            <div className={introClasses}>
              <div className="c-articleheader c-articleheader--alert">
                <div className="c-articleheader__inner-container">
                  <h1 className="c-articleheader__heading">
                    {Render.Property(props.Content.Heading, 'Heading')}
                  </h1>
                  <div className="preamble">
                    {Render.PropertyAsHTML(props.Content.Preamble, 'Preamble')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="columns medium-centered medium-8 large-6 u-text-center">
              <Render.Block
                blocks={props.Content.MainContent}
                propertyName="MainContent"
                currentPageProps={props}
              >
                <Render.BlockTypeRenderer Blocks={Blocks} />
              </Render.Block>
            </div>
          </div>
        </Section>
      )}
    </main>
  );
};

export default ErrorPage404;
